/**
 * List of events used by promoted price widget
 *
 */
export const promotedPrice = {
  PROMOTED_PRICE_DATA_LOADED: 'promotedPriceLoaded'
}
